import { Link, useParams } from 'react-router-dom';
import Today from './Today.jsx';
import { formatDate } from '../lib/format.js';
import NotFound from '../components/NotFound.jsx';

// /archive/:date takes anything the router gives it, so the shape is checked
// before a fetch is spent on it and before formatDate turns "not-a-date" into
// "Invalid Date" in a page title.
const YMD = /^\d{4}-\d{2}-\d{2}$/;

export default function Archive() {
  const { date } = useParams();

  if (!YMD.test(date || '')) {
    return (
      <NotFound title="No brief for that date." seoTitle="No brief here · Charleston.Vacations">
        Archive links look like /archive/2026-09-19.{' '}
        <Link to="/" className="text-navy-700 underline">Today's brief</Link> is
        always current.
      </NotFound>
    );
  }

  // The title spells the date out ("Monday, August 10, 2026"), not the raw
  // route param; it renders only once the brief stored under that key has
  // loaded, so the date here is always a real YYYY-MM-DD. The on-page label
  // is a kicker with no date, because the dateline right above it has one.
  return (
    <Today
      briefPath={`/api/get-brief?date=${date}`}
      archiveLabel="From the archive"
      seoTitle={`Charleston Brief for ${formatDate(date)} · Charleston.Vacations`}
    />
  );
}
